import {Anchor} from "../core/Anchor";
import {BitmapText} from "../core/BitmapText";
import {Sprite} from "../core/Sprite";
import {Assets} from "../data/Assets";
import {Button} from "./Button";

export class LabelButton extends Button {

    public label?: string;
    public labelSize: number = 24;
    public labelTint: number = 0xa2aac3;
    public labelOffset?: number;

    public onLayout() {
        if (this.label) {
            const text = this.visuals.addChild(new BitmapText(
                this.label,
                {font: {name: Assets.fontGrandstander.assetName, size: this.labelSize}, tint: this.labelTint},
                Anchor.middleCenter,
            ));
            text.x = this.sprite!.width * (0.5 - this.sprite.anchor.x);
            text.y = this.sprite!.height * (1 - this.sprite.anchor.y) + (this.labelOffset !== undefined ? this.labelOffset : 20);

            const rect = this.visuals.addChild(new Sprite(PIXI.Texture.WHITE, Anchor.topCenter));
            rect.alpha = 0;
            rect.x = text.x;
            rect.y = text.y - text.height;
            rect.width = text.width;
            rect.height = text.height * 2;
        }
    }
}
